<div class=" lg:h-[376.81px] lg:w-[450.09px] md:h-[376.81px] md:min-w-[450.09px] md:rotatingBlueMd sm:min-w-[450.09px] sm:rotatingBlueMd">

</div>
<div class=" lg:h-[376.81px] lg:w-[450.09px] md:h-[376.81px] md:min-w-[450.09px] md:rotatingBlue2Md sm:min-w-[450.09px] sm:rotatingBlueMd">

</div>
